export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

export const toInt = (value: string | number | undefined) => {
  if (!value) return 0
  const val = +value
  if (isNaN(val)) return 0
  return Math.floor(val)
}
